/**
 * Node.js 入口
 * 引用 base 模块的全部导出，并额外加载 Node adapter
 *
 * 注意：此文件仅通过 webpack 打包（非 tsc 直接编译），
 * webpack alias 会将 @cloudbase/app 解析到 packages/app 源码目录。
 */
// @ts-ignore - webpack alias resolves this
import cloudbase from '@cloudbase/app'
// @ts-ignore - webpack alias resolves this
import pkg from '@cloudbase/app/package.json'

cloudbase.registerVersion(pkg.version)

// Node 环境下加载 Node adapter
try {
  // eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
  const { getSdkVersion } = require('@cloudbase/app/src/constants/common')
  // eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
  const nodeAdapter = require('@cloudbase/app/src/libs/adapter-node')

  cloudbase.useAdapters(nodeAdapter.default)

  // 将 node-sdk 常用的静态属性/方法挂到 cloudbase 实例上
  const cb = cloudbase as any
  cb.version = getSdkVersion()
  cb.SYMBOL_CURRENT_ENV = nodeAdapter.SYMBOL_CURRENT_ENV
  cb.SYMBOL_DEFAULT_ENV = nodeAdapter.SYMBOL_DEFAULT_ENV
  cb.parseContext = nodeAdapter.parseContext
  cb.getCloudbaseContext = nodeAdapter.getCloudbaseContext
} catch (error) {
  // Node adapter 加载失败时静默处理
}

declare global {
  interface Window {
    cloudbase: any
  }
}
try {
  ;(window as Window).cloudbase = cloudbase
} catch (e) {}
// @ts-ignore
export = cloudbase
export default cloudbase
